import { AfterViewInit, Component, computed, ElementRef, HostListener, inject, Signal, ViewChild } from '@angular/core';
import { TopbarComponent } from '../../components/minisite/topbar/topbar.component';
import { FooterComponent } from '../../components/minisite/footer/footer.component';
import { OverlayComponent } from '@components/minisite/overlay/overlay.component';
import { DvmService } from '@services/dvm.service';
import { AppViews } from '@models/enums/dvm/DvmViews.enum';
import { Viewer3dService } from '@3ddv/ngx-dvm-internal';
import { PortalService } from '@services/portal.service';
import { CdkPortalOutlet, ComponentPortal } from '@angular/cdk/portal';
import { MenuService } from '@services/components/menu.service';
import { BottomSheetComponent } from '@components/minisite/footer/bottom-sheet/bottom-sheet.component';
import { SearchService } from '@services/components/search.service';
import { BenefitsService } from '@services/benefits.service';

@Component({
  selector: 'app-viewer-layout',
  standalone: true,
  imports: [
    TopbarComponent,
    OverlayComponent,
    FooterComponent,
    BottomSheetComponent,
    CdkPortalOutlet
  ],
  viewProviders: [
    MenuService,
    SearchService,
    BenefitsService,
  ],
  templateUrl: './viewer-layout.component.html',
  styleUrl: './viewer-layout.component.css'
})
export class ViewerLayoutComponent implements AfterViewInit {

  // VIEW CHILDS
  @ViewChild('mainContainer', { static: true })
  private readonly mainContainer!: ElementRef<HTMLElement>;

  // HOST LISTENERS
  @HostListener('window:keydown', ['$event'])
  public handleFullScreen(event: KeyboardEvent): void {
    
    if (event.key === 'F11' && this.view() === AppViews.Pano) {
      event.preventDefault();
      this.dvmService.viewer3d.toggleFullscreen();
    }

  }

  // SERVICES
  private readonly dvmService:     DvmService              = inject(DvmService);
  private readonly portalService:  PortalService           = inject(PortalService);

  // GLOBAL STATE
  private readonly view:           Signal<AppViews | null> = this.dvmService.view;

  // COMPONENT STATE
  public readonly  portalContent:  Signal<ComponentPortal<unknown>|null> = this.portalService.portalContent;
  public readonly  hideGradients:  Signal<boolean>          = computed((): boolean => this.view() === AppViews.Pano);

  // LIFECYCLE HOOKS
  ngAfterViewInit(): void {
    this.initComponent();
  }

  // METHODS
  /**
   * Inicializador del layout del viewer.
   */
  private initComponent(): void {

    this.overrideFullscreen();

    // init methods para el viewer layout...

  }

  /**
   * Sobreescribe el elemento del fullscreen del viewer.
   */
  private overrideFullscreen(): void {

    const viewer3d: Viewer3dService = this.dvmService.viewer3d;

    viewer3d.waitInitialize().subscribe((): void => viewer3d.interface.overrideFullscreenElement(this.mainContainer.nativeElement));

  }

}